import React from "react";
import { Button, dialog } from "../../../../nq-component";
import InputFactory from "../../../../components/InputFactory";
import { saveFileUseCase } from "../../../../usecases/file";
function DialogRequest({ schema, onChangeData, handleSubmit }) {
  function handleChange(value, field) {
    onChangeData(value, field);
  }

  return (
    <form onSubmit={() => handleSubmit()}>
      <div className="p-4">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="d-flex align-items-center align-self-start gap-2">
            <i
              className="rounded bi bi-person-circle fs-2 px-2"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Request
            </h5>
          </div>
          <div className="px-3">
            <div className="w-100 mb-3">
              <label className="form-label fw-bold">
                Select Type
                <span className="text-danger ms-1 fw-lighter">*</span>
              </label>
              <InputFactory
                type="String"
                _type="Enum"
                options={["Request for Termination", "Transfer of Assignment"]}
                field="requestType"
                onChange={(value, field) => handleChange(value, field)}
                placeholder="Select Type"
                required
              />
            </div>
            <div className="w-100 mb-3">
              <label className="form-label fw-bold">
                Reason
                <span className="text-danger ms-1 fw-lighter">*</span>
              </label>
              <InputFactory
                className="w-100"
                type="String"
                _type="Text"
                field="remarks"
                onChange={(value, field) => handleChange(value, field)}
                placeholder="Enter Reason"
                required
              />
            </div>
            <div className="w-100 mb-3">
              <label className="form-label fw-bold">
                File Attachment
                <span className="text-danger ms-1 fw-lighter">*</span>
              </label>
              <InputFactory
                className="w-100"
                type="MultipleFile"
                field="attachment"
                saveFile={saveFileUseCase()}
                onChange={(value, field) => handleChange(value, field)}
                placeholder="Enter Reason"
                required
                multi={true}
                multiple
              />
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mb-3">
        <button
          type="submit"
          className="btn text-white ms-2"
          style={{ backgroundColor: "#D18237" }}
        >
          Apply
        </button>
        <button
          className="btn btn-secondary text-dark ms-2"
          onClick={() => dialog.close()}
        >
          Close
        </button>
      </div>
    </form>
  );
}

export default DialogRequest;
